import { render } from "./AddBonLivraisonPage.vue?vue&type=template&id=ce2c12a2&ts=true"
import script from "./AddBonLivraisonPage.vue?vue&type=script&lang=ts"
export * from "./AddBonLivraisonPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__